document.addEventListener("DOMContentLoaded", function () {
    const introWithTab = document.querySelector(".intro-with-tab");
    if (introWithTab) {
        const tabs = document.querySelectorAll(".intro-with-tab .tab-div .text-wrapper");
        const contents = document.querySelectorAll(".intro-with-tab .tab-text .img-wrap");
        const mobileContent = document.querySelector(".intro-with-tab .row .content");
        const dropDown = document.querySelector(".intro-with-tab button.open");
        const dropDownText = dropDown.querySelector("span");
        const contentWrap = document.querySelector(".intro-with-tab .content-wrap");
        const animationDuration = 500;
        if (tabs.length > 0 && contents.length > 0) {
            tabs[0].classList.add("active");
            contents[0].classList.add("active");

            console.log(tabs)
            const tabHeading = tabs[0].querySelector(".arrow-wrap");
            const innerWrap = tabs[0].querySelector(".inner-wrapper");
            const firstTabText = tabHeading.textContent;
            const firstTabContent = innerWrap.innerHTML;
            const firstHeading = tabHeading.innerHTML
            mobileContent.innerHTML = firstHeading + firstTabContent;
            innerWrap.style.height = "auto";
            innerWrap.style.display = "block";
        }
        function slideUp(element) {
            element.animate([
                { height: element.scrollHeight + "px" },
                { height: "0" }
            ], {
                duration: animationDuration,
                easing: "ease"
            }).onfinish = function () {
                element.style.height = "0";
                element.style.display = "none";
            };
        }
        function slideDown(element) {
            element.style.display = "block";
            element.animate([
                { height: "0" },
                { height: element.scrollHeight + "px" }
            ], {
                duration: animationDuration,
                easing: "ease"
            }).onfinish = function () {
                element.style.height = element.scrollHeight + "px";
            };
        }
        tabs.forEach((tab, index) => {
            tab.addEventListener("click", function () {
                const target = this.querySelector(".inner-wrapper");
                document.querySelectorAll(".inner-wrapper").forEach(child => {
                    if (child !== target) {
                        slideUp(child);
                    }
                });
                slideDown(target);
                tabs.forEach(tab => tab.classList.remove("active"));
                contents.forEach(content => content.classList.remove("active"));
                tab.classList.add("active");
                contents[index].classList.add("active");
                dropDown.classList.remove("active");
                const tabHeading = tab.querySelector(".arrow-wrap");
                const headingWrap = tab.querySelector(".arrow-wrap");
                const innerWrap = tab.querySelector(".inner-wrapper");
                const tabText = tabHeading.textContent;
                const tabContent = innerWrap.innerHTML;
                const headingContent = headingWrap.innerHTML;
                mobileContent.innerHTML = headingContent + tabContent;
                if (contentWrap.classList.contains("active")) {
                    contentWrap.classList.remove("active");
                }
            });
        });
        dropDown.addEventListener("click", function () {
            contentWrap.classList.toggle("active");
            dropDown.classList.toggle("active");
        });
    }
});
